import React from 'react';
import { motion } from 'framer-motion';
import { ShieldIcon } from './Icons';
export function GuaranteeSection() {
  return <section className="py-20 bg-softwhite" data-id="element-52">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-53">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-sage/10 border-2 border-sage/20 rounded-3xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-54">
          {/* Decorative background icon */}
          <ShieldIcon className="absolute -right-10 -bottom-10 w-64 h-64 text-sage/5 -z-10" data-id="element-55" />

          <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center mx-auto mb-6 shadow-md text-sage" data-id="element-56">
            <ShieldIcon className="w-10 h-10" data-id="element-57" />
          </div>

          <h2 className="text-3xl md:text-4xl font-playfair font-bold text-charcoal mb-6" data-id="element-58">
            Mi Garantía de "Paz Mental" de 7 Días
          </h2>

          <p className="text-lg md:text-xl text-charcoal-light font-sans leading-relaxed max-w-2xl mx-auto" data-id="element-59">
            Prueba el método. Lee los libros. Aplica las técnicas del Nervio
            Vago. Si en 7 días no te sientes menos inflamada, con más energía y
            más tranquila,{' '}
            <strong className="text-charcoal font-semibold" data-id="element-60">
              te devuelvo el 100% de tu dinero.
            </strong>{' '}
            Sin preguntas. El riesgo es todo mío.
          </p>
        </motion.div>
      </div>
    </section>;
}